// React Imports
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Header from '../components/Header';
import {Pages} from '../common/vars';
import {withRouter} from 'react-router-dom';

// Elements
import FooterLogo from '../elements/FooterLogo';
import TextBlock from '../elements/TextBlock';
import ImageText from "../elements/ImageText";
import SvgImageLoader from '../elements/SvgImageLoader';

// Images
import collage from '../../images/pages/about/about__collage.jpg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import collageSvg from '-!raw-loader!../../images/pages/about/about__collage.svg';
import frame from '../../images/pages/about/about__frame.jpg';
import frameThumbnail from '../../images/pages/about/about__frame--thumbnail.jpg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import frameSvg from '-!raw-loader!../../images/pages/about/about__frame.svg';

// Styles
import '../../styles/pages/about.css';
import '../../styles/pages/page.css';

class AboutPage extends Component {

    page = Pages[0];
    content = this.page.content;
    networks = this.page.networks;

    render() {
        return (
            <article className="page about">
                <Header image={this.page.img} svg={this.page.svg} title={this.page.name} subtitle={this.page.subtitle}/>
                <div className="page__content">
                    <TextBlock title={this.content[0].title} content={this.content[0].content}
                               className="text-block--first text-block--left text-block--small-left"/>
                    <SvgImageLoader class="about__collage" image={collage} svg={collageSvg} alt="Ander Murias"/>
                    <TextBlock title={this.content[1].title} content={this.content[1].content}
                               className="text-block--dark text-block--left text-block--small-left"/>
                    <ImageText image={frame} title={this.content[2].title} svg={frameSvg} thumbnail={frameThumbnail}
                               content={this.content[2].content}/>
                </div>
                <FooterLogo/>
            </article>
        );
    }
}

const mapStateToProps = state => {
    return {
        about: state.about,
    }
};

export default withRouter(connect(mapStateToProps)(AboutPage));


// WEBPACK FOOTER //
// ./src/js/pages/AboutPage.js